import {
  LOCATIONVEHICLE_FETCHING,
  LOCATIONVEHICLE_FAILED,
  LOCATIONVEHICLE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOCATIONVEHICLE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case LOCATIONVEHICLE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case LOCATIONVEHICLE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
